import Hero from "../components/Hero";
import Services from "../components/Services";
import About from "../components/About";
import Reviews from "../components/Reviews";
import BookingForm from "../components/BookingForm";
import CTA from "../components/CTA";
import Gallery from "../components/Gallery";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import { useSEO } from "../lib/seo";

export default function Home() {
    useSEO({
        title:
            "Bursa Masaj Salonu — Cegu Masaj Salonu Özlüce | Profesyonel Masaj",
        description:
            "Bursa Nilüfer Özlüce'de profesyonel masaj hizmeti. Klasik, yağlı, medikal, Thai, sultan masajı ve jakuzi. Uzman terapistler, hijyenik salon, WhatsApp'tan hızlı randevu.",
        keywords:
            "Bursa Masaj Salonu, Özlüce Masaj Salonu, Bursa Spa Merkezi, Klasik Masaj Bursa, Yağlı Masaj Bursa, Medikal Masaj Bursa, Thai Masajı Bursa, Sultan Masajı Bursa, Bursa Wellness, Cegu Masaj",
        canonical: "/",
    });

    return (
        <main data-testid="home-page">
            <Hero />
            <Services />
            <About />
            <Reviews />
            <BookingForm />
            <CTA />
            <Gallery />
            <FAQ />
            <Contact />
        </main>
    );
}
